import { Button, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";

type CannotArchiveModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const CannotArchiveModal = ({ isOpen, onClose }: CannotArchiveModalProps) => (
  <ModalV2
    show={isOpen}
    onHide={onClose}
    title=""
    size="small"
    data-testid="cannot-archive-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" alignItems="center" gap={SPACING.MEDIUM}>
        <Icon type="exclamation-circle" size="xx-large" color={Colors.Danger500} />
        <Text variant="strong-xl">Data package cannot be archived</Text>
        <Text variant="secondary-md" align="center">
          You cannot archive this data package while it is in use by active templates. Archive
          the associated templates before trying again.
        </Text>
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="column" gap={SPACING.SMALL}>
        <Button variant="neutral" onClick={onClose} isFullWidth>
          Ok, got it
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
